<template>
    <div class="filter-component-container d-flex align-center flex-fill">
        <!-- search -->
		<!--<v-text-field
            label="Solo"
            placeholder="Buscar"
            v-model="searchText"
            rounded
            solo
            :append-icon="showFilter ? 'mdi-menu-up' : 'mdi-menu-down'"
            prepend-inner-icon="mdi-magnify"
            @click:append="showFilterModal()"
        ></v-text-field>-->
        <!-- Filter -->
        <v-card class="container">
            <!-- filter 1 -->
            <v-row>

                <!-- Level -->                
                <!--<v-col class="d-flex" cols="12" sm="6" md="2">
                    <GroupSelect
                        :items="currentSubject"
                        placeholder="Nivel"
                        :setData="setNivel"
                        :required="true"
                        :updateMode="{
                            status: $route.params.id ? true : false,
                            currentSelected: $route.params.id
                                ? getLesson.category.categoryId
                                : ''
                        }"
                    />
                </v-col>--> 

                <!-- Level -->                
                <v-col class="d-flex" cols="12" sm="6" md="2">
                    <v-select
                        dense
                        v-model="level"
                        :items="levelsOrder"
                        label="Nivel"
                        outlined
                        rounded
                        :item-text="item => item.name"
                        :item-value="item => item.categoryId"
                    ></v-select>
                </v-col>

                <!-- Cource -->
                <v-col class="d-flex" cols="12" sm="6" md="2">
                    <v-select
                        dense
                        v-model="cource"
                        :items="this.sectionsItems"
                        label="Curso"
                        outlined
                        rounded
                        :item-text="item => item.abbreviation"
                        :item-value="item => item.sectionId"
                    ></v-select>
                </v-col>
                <!-- subject -->
                <v-col cols="12" sm="6" md="2">
                    <v-select
                        dense
                        v-model="subject"
                        :items="subjectListFiltered"
                        label="Asignatura"
                        outlined
                        rounded
                        :item-text="item => capitalizeFirstLetter(item.name)"
                        :item-value="item => item.subjectId"
                    ></v-select>
                </v-col>
                <!--:items="lessonInfo.subjectList"-->
                <!-- Unit -->
                <v-col class="d-flex" cols="12" sm="6" md="2">
                    <v-select
                        dense
                        v-model="unit"
                        label="Unidad"
                        outlined
                        rounded
                        :items="lessonInfo.unitList"
                        :item-text="item => capitalizeFirstLetter(item.name)"
                        :item-value="item => item.unitId"
                    ></v-select>
                </v-col>
                
                <v-col class="d-flex" cols="12" sm="6" md="2">
                <v-btn  v-if="!showFilter"
                		text
                        rounded
                        color="white"
                        class="text-capitalize"
                        @click="showFilterModal()"
                    >
                        <span class="romaPrimary--text">Más filtros</span>
                    </v-btn>
                    <v-btn  v-if="showFilter"
                		text
                        rounded
                        color="white"
                        class="text-capitalize"
                        @click="hideFilter()"
                    >
                        <span class="romaPrimary--text">Ocultar filtros</span>
                    </v-btn>                    
                </v-col>
                
                <v-col class="d-flex" cols="12" sm="6" md="2">
                    
                    <v-btn rounded color="blue lighten-1" dark elevation="1" block @click="search()">
			          <v-icon left> mdi-magnify </v-icon>Buscar</v-btn
			        >
                    
                </v-col>
                
            </v-row>

            <!-- filter 2-->
            <v-row v-if="showFilter" >

                <v-col class="d-flex" cols="12" sm="6" md="3">
	                <v-text-field
                        placeholder="Titulo"
			            v-model="searchText"
			            @keyup="inputSearch"
			            rounded
                        outlined
                        dense
                        class="input_title"
			        ></v-text-field>
			    </v-col>

                <v-col class="d-flex" cols="12" sm="6" md="3">
                    <v-select
                        dense
                        :items="this.meses"
                        v-model="mes"
                        label="Mes"
                        :item-text="item => item.name"
                        :item-value="item => item.id"
                        outlined
                        rounded
                    ></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6" md="3">
                    <v-select
                        dense
                        :items="this.items"
                        v-model="state"
                        label="Estado Edición"
                        :item-text="item => item.name"
                        :item-value="item => item.id"
                        outlined
                        rounded
                    ></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6" md="3">
                    <v-select
                        dense
                        :items="this.statesLesson"
                        v-model="lessonActive"
                        label="Estado Clase"
                        :item-text="item => item.name"
                        :item-value="item => item.id"
                        outlined
                        rounded
                    ></v-select>
                </v-col>

                <!--<v-col class="d-flex" cols="12" sm="6" md="3">
                    <v-select
                        dense
                        :items="items"
                        v-model="deadLine"
                        label="Fecha de entrega"
                        outlined
                        rounded
                    ></v-select>
                </v-col>-->

                <!--<v-col class="d-flex" cols="12" sm="6" md="3">
                    <v-select
                        dense
                        :items="items"
                        v-model="pie"
                        label="Flag Plan Pie"
                        outlined
                        rounded
                    ></v-select>
                </v-col>-->
            </v-row>

            <!-- submit -->
            <!-- <v-row class="justify-end align-center">
            </v-row>-->
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
//import GroupSelect from "@/components/commons/RomaGroupSelect";
import { debounce } from "vue-debounce";

export default {
    name: "RomaFilter",
    data() {
        return {
            title: "",
            state: "",
            lessonActive: "",
            deadLine: "",
            pie: "",
            subject: "",
            level: "",
            unit: "",
            cource: "",
            mes: "",
            searchText: "",
            statesLesson: [{id:'ACTIVO',name:'ACTIVAS'}, {id:'INACTIVO',name:'INACTIVAS'},{id:'',name:'TODAS'}],
            items: [{id:'EN_EDICION',name:'EN EDICION'},{id:'PUBLICADO',name:'PUBLICADO'},{id:'CERRADO',name:'CERRADO'},{id:'ARCHIVADO',name:'ARCHIVADO'}],
            meses: [{id:1,name:'Enero'},{id:2,name:'Febrero'},{id:3,name:'Marzo'},{id:4,name:'Abril'},
            	   {id:5,name:'Mayo'},{id:6,name:'Junio'},{id:7,name:'Julio'},{id:8,name:'Agosto'},
            	   {id:9,name:'Septiembre'},{id:10,name:'Octubre'},{id:11,name:'Noviembre'},{id:12,name:'Diciembre'}],
            showFilter: false,
            sectionsItems: [],
            levels:[],
            subjectListFiltered:[],
            fullCategories:[]
        };
    },
    components: {
         //GroupSelect
    },
    computed: {
        ...mapGetters({
            //lessonInfo: "getLessonFilterInformation",
            lessonInfo: "getLessonInformation",
            user: "getUserData"
        }),
        // variación del que se usa en Form new Lesson (filtra por id)
        currentSubject() {
            const subjectList = this.lessonInfo.subjectList
                ? this.lessonInfo.subjectList
                : [];
            const currentSubject = subjectList.filter(subject => {
                // modificado aca
                return subject.subjectId === this.subject;
            });
            return currentSubject;
        },
        levelsOrder(){

        const fullCategories = [];

            if(this.lessonInfo === undefined || this.lessonInfo.educationList === undefined){
                return fullCategories;
            }

            this.lessonInfo.educationList.forEach(education => {
                    education.categories.forEach(category=>{
                        fullCategories.push(category);
                    }
                );

            });

            return fullCategories;
        },
        currentEducations() {

            const educations = this.lessonInfo.educationList
                ? this.lessonInfo.educationList
                : [];

            console.log("Educations: ",educations);

            // deconstruct Educations
            const newArr = [];

            if(educations!==undefined){
                educations.forEach(item => {
                    newArr.push({
                        header: item.name
                    });
                    item.categories?.forEach(category => {
                        newArr.push(category);
                    });
                    newArr.push({ divider: true });
                });
            }

            return newArr;
        },
        currentCources() {
            return this.currentSubject.educations
                ? this.currentSubject.educations[0].categories[0].sections
                : [];
        },
        currentSubjectList() {
            return this.lessonInfo ? this.lessonInfo.subjectList : [];
        },
        currentInstitutionId() {
            return this.user && this.user.institutionContext
                ? this.user.institutionContext.institutionId
                : [];
        }
    },
    methods: {
        ...mapActions({
            toastSuccess: "toastSuccess",
            toastError: "toastError",
            getLessonInfo: "actionGetFilterInformationLesson",
            actionGetLessons: "actionGetLessons"
        }),
        showFilterModal() {
            this.showFilter = !this.showFilter;
            this.getLessonInfo(this.user);
        },
        inputSearch: debounce(function() {
            this.search();
        }, 700),

        search() {
            const level = this.level ? `categoryId=${this.level}` : "";
            // const title = this.title ? `title=${this.title}` : "";
            // const textQuery = this.searchText ? `&text=${this.searchText}` : "";
            const institutionId = this.user.institutionContext.institutionId
                ? `&institutionId=${this.user.institutionContext.institutionId}`
                : "";
            const personId = this.user.personId
                ? `&personId=${this.user.personId}`
                : "";
            const sectionId = this.cource ? `&sectionId=${this.cource}` : "";
            const subjectId = this.subject ? `&subjectId=${this.subject}` : "";
            const unitId = this.unit ? `&unitId=${this.unit}` : "";
            const title = this.searchText ? `&title=${this.searchText}` : "";
            const estadoClase = this.state ? `&state=${this.state}` : "";
            const mesValue = this.mes ? `&month=${this.mes}` : "";
            const lessonState = this.lessonActive ? `&isActive=${this.lessonActive}` : "";

            const query = `${level}${institutionId}${personId}${sectionId}${sectionId}${subjectId}${unitId}${title}${estadoClase}${mesValue}${lessonState}`;
            this.actionGetLessons({
                searchQuery: query,
                pageNumber: 0,
                pageSize: 8
            });             
            //this.hideFilter();
            return false;
        },
        setNivel(level) {
            this.level = level;
        },
        hideFilter() {
            this.showFilter = false;
        },
        cancelSearch() {
        	this.subject = "";
        	this.title = "";
            this.state = "";
            this.deadLine = "";
            this.pie = "";
            this.subject = "";
            this.level = "";
            this.unit = "";
            this.cource = "";
            this.searchText = "";
            this.hideFilter();
        },
        capitalizeFirstLetter(string) {
            const text =
                string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
            return text;
        }
    },
    watch: {    
        /*subject() {
            if (this.unit) {
                // this.planUnit ? this.planUnit = "" : '';

                this.actionGetPlanUnits({
                    idUnidad: this.unit,
                    idAsignatura: this.currentSubject[0].subjectId
                });
            }
        },
        unit(newValue, oldValue) {
            // this.planUnit = "";
            this.actionGetPlanUnits({
                idUnidad: newValue,
                idAsignatura: this.currentSubject[0].subjectId
            });
        },

        planUnit(newValue, oldValue) {
            // console.log(newValue);
            this.actionGetPlanUnitActivities(newValue);
            this.actionGetWeeks(newValue);
        },*/

        cource: function(){

            console.log("course (section id) Selected:",this.cource);
            this.subjectListFiltered = [];
            this.lessonInfo.subjectList.forEach(subject => {
                let aux = false;
                subject.educations.forEach( education => {
                    education.categories.forEach( category => {
                            category.sections.forEach( section => {
                                if(section.sectionId == this.cource){
                                    aux = true;
                                }
                            });
                    });
                });

                if(aux === true ){
                    this.subjectListFiltered.push(subject);
                }

            });

        },
        level: function() {
            // se limpia select cource
            if (!this.$route.params.id) {
                this.cource = null;
            }

            // AUXILIAR NIVEL EDUCATIVO

            //let aux = 0;
            console.log("level Selected:",this.level);

            // Niveles de eduacion (Basico / Medio)
            //this.currentSubject[0].educations.forEach(educationLevel => {
            /*this.lessonInfo.educationList.forEach(educationLevel => {
                // Niveles (1ero, 2do, 3ro, ...)
                const grado = educationLevel.categories.findIndex(
                    level => level.categoryId == this.level
                );

                if (grado != -1) {
                    aux = this.lessonInfo.educationList.findIndex(
                        element => element == educationLevel
                    );
                }
            });*/

            //console.log("aux Selected:",aux);

            //const categories = this.lessonInfo.educationList[aux].categories
            //    ? this.lessonInfo.educationList[aux].categories
            //    : [];

            const courses = this.lessonInfo.courseList;
 
            const index = courses.findIndex(
                course => course.category.categoryId == this.level
            );

            /*const index = categories.findIndex(
                categoria => categoria.categoryId == this.level
            );*/
            if(courses[index] !== undefined){
                this.sectionsItems= [];
                const cursos = courses[index].sections;
                this.sectionsItems = cursos;
            }else{
                this.sectionsItems = [];
            }
            
        }

    }
};
</script>

<style lang="scss">
// para que se centre con respecto al filter header y no al filtro de busqueda
.header-filter {
    position: relative;
}
.filter-component-container {
    .v-text-field__details {
        display: none;
    }
}
.filter-btn.filter-btn {
    box-shadow: 0px 6px 15px #00000029;
    height: 65px !important;
    min-width: 161px !important;
    border-radius: 33px !important;
    // display: grid;
    // grid-template-columns: 15px max-content 1fr;
    span {
        font-size: 18px;
        margin: 0 10px;
        // display: block;
        // grid-column: 2 / 3;
    }
    .v-icon {
        font-size: 32px;
        // grid-column: 1 / 2;
        // justify-self: center;
    }
}
.filter-wrapper {
    .filter-container {
        position: absolute;
        z-index: 50;
        padding: 1rem;
        min-width: 910px;
        top: calc(100% + 1rem);
        left: 50%;
        transform: translateX(-50%);
        border-radius: 9px !important;
        box-shadow: 0px 3px 6px #00000052 !important;
        // border-radius: 15px;
        // width: 120%;
        // width: calc(100% + 1rem) !important;
        // background-color: #bada55;
    }

    .icon-search {
        color: #72237c;
    }

    .theme--light.v-icon {
        color: #72237c;
    }

    .v-input__control {
        height: 50px !important;
    }

    .filter-down {
        border-radius: 50%;
        width: 28px;
        height: 28px;
    }

    .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
        min-height: 50px !important;
    }

    .btn-search {
        border-radius: 100px;
        padding: 10px 30px;
        border: solid 1px #c3c3c3;
        height: 60px;
        width: 30%;
        box-shadow: 0 3px 5px 3px rgba(0, 0, 0, 0.02),
            0 6px 10px 0 rgba(0, 0, 0, 0.06), 0 1px 18px 0 rgba(0, 0, 0, 0.1);
        i {
            margin-left: 15px;
            font-size: 1.85em !important;
        }
    }

    // .input_title{
    //     max-height: 40px !important; 

 
    // }

    // .v-text-field.v-text-field--outlined .v-input__control {
    // max-height: 40px !important; 
    // }
    @media (min-width: 1904px) {
    }
    @media (min-width: 1264px) and (max-width: 1903px) {
    }
    @media (min-width: 960px) and (max-width: 1263px) {
    }
    @media (min-width: 600px) and (max-width: 959px) {
        // position: relative;
        .filter-container {
            min-width: 50%;
            width: 80%;
        }
    }
    @media (max-width: 599px) {
        .filter-container {
            min-width: 50%;
            width: 100%;
        }
        .btn-search {
            width: 50%;
        }
    }
}
</style>
